/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import {useDispatch} from "react-redux"; // Import hook for dispatching actions in Redux
import {GetPreview} from "../../../reduxToolkit/Cards/CardsApi"; // Import the API function to get card preview data
import {useEffect, useRef, useState} from "react"; // Import React hooks for side effects and state management
import { useTranslation } from 'react-i18next'; // Import translation hook for internationalization

// Main component to handle card preview logic
const CardPreviewApp = ({currentId}) => {
    // Translation hook for localization
    const { t } = useTranslation();

    // Redux dispatch hook to trigger actions
    const dispatch = useDispatch();

    // State to store the raw preview data of the card
    const [previewRaw, setPreviewRaw] = useState(null);

    // Define constant values for card dimensions and background color
    const cardWidth = 300; // Card width in pixels
    const cardHeight = 460; // Card height in pixels
    const cardBackgroundColor = 'white'; // Card background color

    const stageFront = useRef();
    const stageBack = useRef();

    // useEffect hook to fetch card preview data when the component mounts or the currentId changes
    useEffect(() => {
        // Dispatch the action to fetch preview data from the API
        dispatch(GetPreview(currentId)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success) {
                    // If the API call is successful, parse the raw data and store it in state
                    setPreviewRaw(JSON.parse(data.raw));
                }
            },
        );
    }, [currentId]); // Dependency array: only re-run the effect when currentId changes

    const handleDownload = (itemRef) => {
        const imageUrl = itemRef.current.toDataURL();  // Obtener la URL de la imagen desde la ref
        const a = document.createElement('a');  // Crear un enlace temporal
        a.href = imageUrl;  // Establecer la URL de la imagen
        a.download = 'imagen_descargada.jpg';  // Nombre de la imagen descargada
        a.click();  // Simula el clic en el enlace para descargar la imagen
    };

    // Return the necessary values for the card preview
    return {
        t, // Translation function
        cardWidth, // Card width
        cardHeight, // Card height
        cardBackgroundColor, // Card background color
        previewRaw, // Preview raw data (parsed)
        stageFront,
        stageBack,
        handleDownload
    }
}

export default CardPreviewApp;
